/**
 * 避免语言代码丢失版路由跳转
 * @param path 要跳转到的路由路径
 */
export const useLocalePush = (path: string) => {
  const localePath = useLocalePath()
  return navigateTo(localePath(path))
}
